export default "__VITE_ASSET__07a3c4ce__"